import { useRouter }           from "next/router";
import { useEffect, useState } from "react";

import { useGetLoggedIn }          from "_common/hooks/auth";
import { useGetProfileData }       from "_common/hooks/auth";
import { useGetAppLocale }         from "_common/hooks/global";
import Toast                       from "_common/toast";
import { copyToClipboard }         from "_common/utils/clientSide";
import { DONATION_PAGE, SITE_URL } from "_config/index";
import { getUserSessions }         from "_services/api/broadcast";

import Presentation from "./presentation";

const component = ( { userProfile, userBroadcasterDetails, userId, isModerator, toggleErrorModal, toggleModeratorOption } ) => {
	/* const log = logger ({ file : "components/templates/UserProfileHeader/container" }); */

	useEffect ( () => {
		setFollowerCount ( userProfile?.follow?.followers );
	}, [ userProfile?.follow?.followers ] );

	useEffect ( () => {
		if ( !userId || !userProfile?.isLive )
			return;

		getUserBroadcastDetails ();
	}, [ userId ] );

	const [ followerCount, setFollowerCount ]                 = useState ( userProfile?.follow?.followers );
	const [ followInfoDialog, setFollowInfoDialog ]           = useState ( { status: false, activeType: "0" } );
	const [ editUserProfileDialog, setEditUserProfileDialog ] = useState ( false );
	const [ broadcastId, setBroadcastId ]                     = useState ( null );
	const [ anchorEl, setAnchorEl ]                           = useState ( null );
	const [ shareAnchorEl, setShareAnchorEl ]                 = useState ( null );
	const [ open, setOpen ]                                   = useState ( false );

	const handleClickOpen = event => {
		if ( !open ) {
			setShareAnchorEl ( event.currentTarget );
			setOpen ( previousOpen => !previousOpen );
		}
	};

	const handleClickAway = () => {
		setOpen ( false );
	};

	const appLocale  = useGetAppLocale ();
	const myProfile  = useGetProfileData ();
	const isLoggedIn = useGetLoggedIn ();

	const router = useRouter ();

	const getUserBroadcastDetails = async () => {
		let params = {
			sportsFanId : userId,
			pageNo      : 1,
			pageSize    : 1
		};

		try {
			const response = await getUserSessions ( params );

			if ( !response || !response.length )
				throw "empty";

			setBroadcastId ( response[0]?.id );
		} catch ( err ) {
			return Toast.error ( "Nothing to play" );
		}

	};

	const toggleDialogInfoBox = type => {
		setFollowInfoDialog ( prev => ( { ...prev, status: !followInfoDialog.status, activeType: type } ) );
	};

	const handleEditUserProfileDialog = () => {
		setEditUserProfileDialog ( !editUserProfileDialog );
	};

	const checkOwnProfile = () => {
		return userId === myProfile?.id?.toString ();
	};

	const isFollowingUser = userProfile && userProfile.isFollowing && userProfile.isFollowing.following;

	const getSrc = () => {
		const source           = `profile/${ userId }`;
		const shareLinkDetails = {
			path: source
		};

		let shareLink = `${ SITE_URL }/${ shareLinkDetails.path }`;

		return shareLink;
	};

	const getDonationSrc = () => {
		let shareLink = `${ DONATION_PAGE }?id=${ userId }`;

		copyToClipboard ( shareLink );
	};

	const handleClick = event => {
		setAnchorEl ( event.currentTarget );
	};

	const handleClose = () => {
		setAnchorEl ( null );
	};

	// handler for routing to live stream
	const handleRedirect = () => {
		if ( userProfile.isLive && broadcastId ) {
			router.push ( `/stream/${ broadcastId }` );
		}
	};

	return (
		<Presentation
			anchorEl               = { anchorEl }
			appLocale              = { appLocale }
			editUserProfile        = { editUserProfileDialog }
			followerCount          = { followerCount }
			followInfoDialog       = { followInfoDialog }
			getDonationSrc         = { getDonationSrc }
			getSrc                 = { getSrc }
			handleClick            = { handleClick }
			handleClickAway        = { handleClickAway }
			handleClickOpen        = { handleClickOpen }
			handleClose            = { handleClose }
			handleRedirect         = { handleRedirect }
			isFollowingUser        = { isFollowingUser }
			isLoggedIn             = { isLoggedIn }
			isModerator            = { isModerator }
			isOwnProfile           = { checkOwnProfile () }
			myProfile              = { myProfile }
			shareAnchorEl          = { shareAnchorEl }
			shareModalOpen         = { open }
			toggleDialogInfoBox    = { toggleDialogInfoBox }
			toggleEditUserProfile  = { handleEditUserProfileDialog }
			toggleErrorModal       = { toggleErrorModal }
			toggleModeratorOption  = { toggleModeratorOption }
			userBroadcasterDetails = { userBroadcasterDetails }
			userId                 = { userId }
			userProfile            = { userProfile }
		/>
	);
};

export default component;
